// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active[data-v-57f5a93a], .fade-leave-active[data-v-57f5a93a] {\n\ttransition: opacity .5s;\n}\n.fade-enter[data-v-57f5a93a], .fade-leave-to[data-v-57f5a93a] {\n\topacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
